import { CustomDropdownOption } from "../Models/shared-data-models.model";

export class TaskConstantsAndData {}

export type WorkItemType = {
    value: number;
    label: string;
};

export type WorkItemPriority = {
    value: number | string;
    label: string;
}

export const WorkItemPriorityListWithStringValues: WorkItemPriority[] = [
    { value: "P0", label: "PO - Extremely Critical" },
    { value: "P1", label: "P1 - Critical" },
    { value: "P2", label: "P2 - Normal Importance" },
    { value: "P3", label: "P3 - Almost Normal Importance" },
    { value: "P4", label: "P4 - Low Priority" },
];

export const WorkItemPriorityListWithStringValuesForPersonal = [
    { value: "P0", label: "Important" },
    { value: "P2", label: "Normal" },
    { value: "P4", label: "Low" },
];

export const PRIORITIES_CONST_LIST = [
    {
        priorityId: 1,
        priorityDesc: "Extremely Critical",
        priorityDisplayAs: "P0 - Extremely Critical",
    },
    {
        priorityId: 2,
        priorityDesc: "Critical",
        priorityDisplayAs: "P1 - Critical",
    },
    {
        priorityId: 3,
        priorityDesc: "Normal Importance",
        priorityDisplayAs: "P2 - Normal Importance",
    },
    {
        priorityId: 4,
        priorityDesc: "Almost Normal Importance",
        priorityDisplayAs: "P3 - Almost Normal Importance",
    },
    {
        priorityId: 5,
        priorityDesc: "Low Priority",
        priorityDisplayAs: "P4 - Low Priority",
    },
];

export const WorkItemTypesList = [
    { value: 1, label: "Task" },
    { value: 2, label: "Parent Task" },
    { value: 3, label: "Child Task" },
    { value: 4, label: "Bug" },
];

export class TaskFilterData {
    public static readonly NoOfDaysOptions: CustomDropdownOption[] = [
        { value: 2, label: "Since Yesterday" },
        { value: 7, label: "In Last 7 Days" },
        { value: 30, label: "In Last 30 Days" },
    ];

    public static readonly PROGRESS_SYSTEM: CustomDropdownOption[] = [
        { value: "DELAYED", label: "Delayed" },
        { value: "WATCHLIST", label: "Watchlist" },
        { value: "ONTRACK", label: "On-Track" },
        { value: "NOTSTARTED", label: "Not-Started (No Delay)" },
        { value: "COMPLETED", label: "Completed" },
    ];

    public static readonly DATE_TYPE_OPTIONS: CustomDropdownOption[] = [
        { value: "taskActStDate", label: "Actual Start Date" },
        { value: "taskActEndDate", label: "Actual End Date" },
        { value: "taskExpStartDate", label: "Expected Start Date" },
        { value: "taskExpEndDate", label: "Expected End Date" },
        { value: "createdDateTime", label: "Created Date" },
        { value: "lastUpdatedDateTime", label: "Last Updated Date" },
    ];
}

export class ProgressSystems {
    static readonly DELAYED = new ProgressSystems("DELAYED", "Delayed", "");
    static readonly WATCHLIST = new ProgressSystems("WATCHLIST", "Watchlist", "");
    static readonly ONTRACK = new ProgressSystems("ONTRACK", "On-Track", "");
    static readonly NOTSTARTED = new ProgressSystems("NOTSTARTED", "Not-Started", "(No Delay)");
    static readonly COMPLETED = new ProgressSystems(
        "COMPLETED",
        "Completed",
        "On Time \n" + "                                                                          Completion",
    );
    static readonly LATE_COMPLETION = new ProgressSystems(
        "LATE_COMPLETION",
        "Late Completion",
        " Late \n" + "                                                                          Completion",
    );

    // private to disallow creating other instances of this type
    private constructor(
        private readonly _key: string,
        private readonly _label: string,
        private readonly _additionalText?: string,
    ) {}

    get key(): string {
        return this._key;
    }

    get label(): string {
        return this._label;
    }

    get additionalText(): string {
        return this._additionalText || "";
    }

    toString() {
        return this.key;
    }
}

export const DefaultResetOption: CustomDropdownOption = { value: null, label: "None" };

export const SCREEN_NAMES = {
    DASHBOARD: "Dashboard",
    TASK_MASTER: "TaskMaster",
    STAT_TASKS_VIEW: "StatTasksView",
    QUICK_CREATE: "QuickCreate",
    CREATE_TASK: "CreateTask",
    UPDATE_TASK: "UpdateTask",
    RECORDED_EFFORT_DRILL_DOWN: "RecordedEffortDrillDown",
    MEETINGS: {
        MAIN: "Meetings",
        MANAGE_MEETINGS: "ManageMeetings",
        CREATE_MEETING: "createmeetings",
        MEETINGS_CALENDAR_VIEW: "MeetingsCalendarView",
        JOIN_MEETING: "JoinMeeting",
    },
    BOARD_VIEW: {
        MY_BOARD_VIEW: "MyBoardView",
        ALL_BOARD_VIEW: "AllBoardView",
    },
    TIME_SHEET: {
        MY_TIME_SHEET: "MyTimeSheet",
        TEAM_TIME_SHEET: "TeamTimeSheet",
    },
    TEAM: {
        CREATE_TEAM: "CreateTeam",
        EDIT_TEAM: "EditTeam",
        MANAGE_TEAMS: "ManageTeams",
    },
    LEAVE_MANAGEMENT: "LeaveManagement",
    LEAVE_REPORT: "leavereport",
    PERSONAL_ORG: {
        MAIN: "PersonalOrg",
        CREATE_PERSONAL_TASK: "CreatePersonalTask",
        UPDATE_PERSONAL_TASK: "UpdatePersonalTask",
        CREATE_PERSONAL_TEAM: "CreatePersonalTeam",
        EDIT_PERSONAL_TEAM: "EditPersonalTeam",
    },
    TASK_COMMENTS: "TaskComments",
    GROUP_CONVERSATIONS: "GroupConversations",
    CHAT: "Chat",
    STICKY_NOTES: "StickyNotes",
    ATTENDANCE: "Attendance",
    TIMELINE: "Timeline",
    TEMPLATES: {
        MANAGE_TEMPLATES: "ManageTemplates",
        VIEW_TEMPLATE: "ViewTemplate",
        CREATE_TEMPLATE: "CreateTemplate",
        EDIT_TEMPLATE: "EditTemplate",
    },
    SPRINTS: {
        MAIN: "Sprints",
        VIEW_SPRINT: "viewsprint",
        CREATE_SPRINT: "CreateSprint",
        EDIT_SPRINT: "EditSprint",
        SPRINT_ANALYSIS: "SprintAnalysis",
        SPRINT_VELOCITY: "SprintVelocity",
    },
    CAPACITY_PLANNING: {
        MAIN: "CapacityPlanning",
        INDIVIDUAL_CAPACITY: "IndividualCapacity",
    },
    MANAGE_PROJECTS: "ManageProjects",
    MANAGE_ORGANIZATION: "ManageOrganization",
    EDIT_PROFILE: "EditProfile",
    EDIT_PREFERENCES: "EditPreferences",
    SEARCH_TASKS: "SearchTasks",
    VOICE_INSTRUCTIONS: "VoiceInstructions",
    CHAT_HELP: "ChatHelp",
    NOTIFICATIONS: "Notifications",
    PERFORMANCE_NOTES: {
        MAIN: "PerformanceNotes",
        TASK_PERFORMANCE_NOTES: "TaskPerformanceNotes",
    },
    CREATE_EPIC: "CreateEpic",
    VIEW_EPIC: "ViewEpic",
    DEPENDENCIES: "Dependencies",
    JIRAMIGRATION: "jiramigration",
    DOCUMENTS: {
        VIEW_DOCUMENT: "viewdocument",
        CREATE_DOCUMENT: "createdocument",
    },
    WORKFLOW: {
        VIEW_WORKFLOW: "viewworkflow",
    },
    OVERTIME: "overtime",
    RELEASES: "release",
};
export const DateTypeConst = {
    TaskExpStartDate : "taskExpStartDate",
    TaskExpEndDate : "taskExpEndDate",
    TaskActStartDate: "taskActStDate",
    TaskActEndDate : "taskActEndDate",
    CreateTaskDate: "createdDateTime",
}